import { FunctionComponent } from 'react';
import { components, OptionProps } from 'react-select';
import { SelectOptionData } from '@/components/SelectFloatingLabel/SelectFloatingLabel';

const CustomOption: FunctionComponent<OptionProps<SelectOptionData>> = (props) => (
  <components.Option {...props} className="py-2" />
);
export default CustomOption;
